// Bulk delete from the signals list (POST /signal/delete with many keys).
// Mirrors the single-key delete's marketplace-conflict handshake: a 409
// with listing info surfaces as ``marketplaceConflict`` so the container
// can render one "Delist & Delete" confirm for the whole batch.
const action = "SIGNAL_DELETE_BULK";
export const REQUEST = action + '_REQUEST';
export const RESPONSE = action + '_RESPONSE';
export const CLEAR = action + '_CLEAR';
export const FAILURE = action + '_FAILURE';
export const MARKETPLACE_CONFLICT = action + '_MARKETPLACE_CONFLICT';
export const MARKETPLACE_CONFLICT_CLEAR = action + '_MARKETPLACE_CONFLICT_CLEAR';

// payload: { keys: [...], streams?: [...], force?: bool }
// ``streams`` are event streams — deleted via the Mongo events store in
// the same batch call (the BE fans out internally).
export const fetchRequest = (payload) => ({ type: REQUEST, payload });
export const fetchSuccess = (response) => ({ type: RESPONSE, payload: response });
export const clearState = () => ({ type: CLEAR });
export const fetchFailure = (error) => ({ type: FAILURE, payload: error });
export const marketplaceConflict = (payload) => ({ type: MARKETPLACE_CONFLICT, payload });
export const clearMarketplaceConflict = () => ({ type: MARKETPLACE_CONFLICT_CLEAR });
